// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as DOM_HTML_Indexed_InputType from "../DOM.HTML.Indexed.InputType/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Events from "../Halogen.HTML.Events/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Halogen_Styled from "../Halogen.Styled/index.js";
import * as Halogen_Styled_DSL from "../Halogen.Styled.DSL/index.js";
import * as Visonum_BulkPingApp_AppHTML from "../Visonum.BulkPingApp.AppHTML/index.js";
import * as Web_UIEvent_KeyboardEvent from "../Web.UIEvent.KeyboardEvent/index.js";
import * as Web_UIEvent_KeyboardEvent_EventTypes from "../Web.UIEvent.KeyboardEvent.EventTypes/index.js";
var inline = /* #__PURE__ */ Halogen_Styled_DSL.inline();
var value = /* #__PURE__ */ Halogen_HTML_Properties.value(Halogen_HTML_Core.isPropString);
var type_ = /* #__PURE__ */ Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var view = function (props) {
    var elTextArea = Visonum_BulkPingApp_AppHTML.styleLeaf(Halogen_HTML_Elements.textarea)("Input")([ inline({
        gridArea: "Input",
        margin: "1px",
        border: "1px solid #ccc",
        padding: "5px",
        borderRadius: "5px",
        fontSize: "10px",
        lineHeight: "15px"
    }) ]);
    var elRoot = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("TextInput")([ inline({
        width: "100%",
        display: "grid",
        gridTemplateColumns: "2fr 3fr",
        gridTemplateRows: "15px auto",
        gridTemplateAreas: Data_String_Common.joinWith(" ")([ "\"Label ErrorText\"", "\"Input Input    \"" ]),
        padding: "2px",
        gap: "2px",
        height: "100%"
    }) ]);
    var elLabel = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.label)("Label")([ inline({
        gridArea: "Label",
        margin: "1px",
        fontSize: "10px",
        fontFamily: "Arial",
        fontWeight: "bold"
    }) ]);
    var elInput = Visonum_BulkPingApp_AppHTML.styleLeaf(Halogen_HTML_Elements.input)("Input")([ inline({
        gridArea: "Input",
        margin: "1px",
        border: "1px solid #ccc",
        height: "25px",
        padding: "5px",
        borderRadius: "5px",
        fontSize: "12px"
    }) ]);
    var elErrorText = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("ErrorText")([ inline({
        gridArea: "ErrorText",
        margin: "1px",
        fontSize: "10px",
        fontFamily: "Arial",
        textAlign: "right",
        color: "red"
    }) ]);
    return elRoot([  ])([ elLabel([  ])([ Halogen_Styled.text(props.label) ]), elErrorText([  ])([  ]), (function () {
        if (props.multiline) {
            return elTextArea([ value(props.value), Halogen_HTML_Events.onValueInput(function (val) {
                return props.onChange(val);
            }) ]);
        };
        return elInput([ value(props.value), type_((function () {
            if (props.password) {
                return DOM_HTML_Indexed_InputType.InputPassword.value;
            };
            return DOM_HTML_Indexed_InputType.InputText.value;
        })()), Halogen_HTML_Events.onValueInput(function (val) {
            return props.onChange(val);
        }), Halogen_HTML_Events["handler$prime"](Web_UIEvent_KeyboardEvent_EventTypes.keydown)(function (ev) {
            return bind(Web_UIEvent_KeyboardEvent.fromEvent(ev))(function (keyEvent) {
                return bind(props.onEnter)(function (action) {
                    var $8 = Web_UIEvent_KeyboardEvent.key(keyEvent) === "Enter";
                    if ($8) {
                        return new Data_Maybe.Just(action);
                    };
                    return Data_Maybe.Nothing.value;
                });
            });
        }) ]);
    })() ]);
};
var defaultProps = /* #__PURE__ */ (function () {
    return {
        label: "",
        value: "",
        onChange: function (v) {
            return Data_Unit.unit;
        },
        multiline: false,
        password: false,
        onEnter: Data_Maybe.Nothing.value
    };
})();
export {
    defaultProps,
    view
};
//# sourceMappingURL=index.js.map
